import { Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { KeyValue } from '@/components/shared/key-value';
import type { DetailsProps } from '@/packages/subsidy-management/interfaces';
import { formatDate } from '@/utils/format-date';

export const RequestData = ({ resourceApprovalsDetails }: DetailsProps) => {
  return (
    <ContentBox>
      <Typography variant="h2" mb={3} color="primary.dark">
        Dados da solicitação
      </Typography>
      <Stack gap={2}>
        <KeyValue
          label="Data da solicitação"
          value={formatDate(resourceApprovalsDetails?.requested_at || '')}
        />
        <KeyValue
          label="Solicitante"
          value={resourceApprovalsDetails?.user?.name || ''}
        />
        <KeyValue
          label="Usuário"
          value={resourceApprovalsDetails?.user?.email || ''}
        />
      </Stack>
    </ContentBox>
  );
};
